import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Login'
import Home from '@/components/Home'
import Welcome from '@/components/Welcome'
import Error from '@/components/Error'
//引入组件-------------------------------------
import Company from '@/components/sysmanager/Company'
import Project from '@/components/sysmanager/Project'
import Role from '@/components/sysmanager/Role'
//----------------------------------------------
import User from '@/components/user/User'
import Worker from '@/components/user/Worker'
import UserView from '@/components/user/UserView'

import QualityDisclose from '@/components/disclose/QualityDisclose'
import SafeDisclose from '@/components/disclose/SafeDisclose'
import SafeRectify from '@/components/rectify/SafeRectify'
import QualityRectify from '@/components/rectify/QualityRectify'

import Register from '@/components/device/Register'
import Material from '@/components/device/Material'
import CheckD from '@/components/device/CheckD'
import Machine from '@/components/device/Machine'

import DeviceData from '@/components/device/data'
import TowerLayout from '@/components/device/TowerLayout'

import TechnologyDrawing from '@/components/technology/drawing'
import TechnologyChange from '@/components/technology/change'
import TechnologyModel from '@/components/technology/model'

import Overviewcom from '@/components/overview/Overview'
import Construction from '@/components/construction/Construction'

import Message from '@/components/message/Message'
import Exam from '@/components/exam/Exam'
import ExamOnline from '@/components/exam/ExamOnline'
import ExamPage from '@/components/exam/ExamPage'
import Examresult from '@/components/exam/ExamResult'

import Discolseview from '@/components/qrcodeview/Discloseview'
import Rectifyview from '@/components/qrcodeview/Rectifyview'

import ModelView from '@/components/model/ModelView'
import Progress from '@/components/progress/Progress'
import CheckEngine from '@/components/progress/CheckEngine'
import ModelEngine from '@/components/model/Engine'
import ProgressEngine from '@/components/progress/EngineView'
import FaceDisclose from "../components/qrcodeview/FaceDisclose";
import CheckDisclose from "../components/qrcodeview/CheckDisclose";


Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },

    {
      path: '/',
      redirect:{
        name:'Home'
      },
      component: Home,
      children: [
        //欢迎页
        { path: '/welcome', component: Welcome, name: '欢迎页' },
        { path: '/sys-company', component: Company, name: '公司管理' },
        { path: '/sys-project', component: Project, name: '项目管理' },
        { path: '/sys-role', component: Role, name: '岗位角色' },
        {path: '/user-register', component: User, name: '管理人员注册登记'},
        {path: '/user-worker', component: Worker, name: '工人注册登记'},


        {path: '/quality-disclose', component: QualityDisclose, name: '质量交底'},
        {path: '/safe-disclose', component: SafeDisclose, name: '安全交底'},
        {path: '/quality-rectify', component: QualityRectify, name: '质量整改'},
        {path: '/safe-rectify', component: SafeRectify, name: '安全整改'},

        {path: '/device-register', component: Register, name: '设备注册'},
        {path: '/device-material', component: Material, name: '资料管理'},
        {path: '/device-check', component: CheckD, name: '设备维保与检查'},
        {path: '/device-data', component: DeviceData, name: '设备数据'},
        {path: '/device-machine', component: Machine, name: '地磅系统'},
        {path: '/device-tower', component: TowerLayout, name: '塔吊布局'},

        {path: '/technology-drawing', component: TechnologyDrawing, name: '图纸管理'},
        {path: '/technology-change', component: TechnologyChange, name: '变更管理'},
        {path: '/technology-model', component: TechnologyModel, name: '模型管理'},

        {path: '/overview', component: Overviewcom, name: '总览' },
        {path: '/construction', component: Construction, name: '绿色施工'},

        {path: '/message', component: Message, name: '工程动态' },

        {path: '/exam', component: Exam, name: '创建考试' },
        {path: '/exam_online', component: ExamOnline, name: '在线考试' },

        {path: '/model', component: ModelView, name: 'BIM模型' },
        {path: '/progress', component: Progress, name: '进度管理' },
      ]
    },
    {
      path: '/discloseview',
      name: 'discloseview',
      component: Discolseview
    },
    {
      path: '/rectifyview',
      name: 'rectifyview',
      component: Rectifyview
    },
    {
      path: '/examview',
      name: 'examview',
      component: ExamPage
    },
    {
      path: '/examresult',
      name: 'examresult',
      component: Examresult
    },
    {
      path: '/userview',
      name: 'userview',
      component: UserView
    },
    {
      path: '/error',
      name: 'Error',
      component: Error
    },
    {
      path: '/checkengine',
      name: 'CheckEngine',
      component: CheckEngine
    },
    {
      path: '/modelengine',
      name: 'ModelEngine',
      component: ModelEngine
    },
    {
      path: '/progressengine',
      name: 'ProgressEngine',
      component: ProgressEngine
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js